import { useMutation, useQuery } from "@apollo/react-hooks";
import { Button, Form, Input, Typography } from "antd";
import React, { useEffect } from "react";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import { useHistory } from "react-router";
import ConfirmDetailsImage from "../../../../Assets/Images/002.jpg";
import { Loader } from "../../../../Components/Loader";
import {
  CONFIRM_USER_DETAILS,
  UPDATE_USER_LAST_SCREEN,
} from "../../../../Graphql/mutations";
import { GET_USER_DETAILS } from "../../../../Graphql/queries";

const { Title } = Typography;

export const ConfirmDetailsPage = () => {
  const user_id = localStorage.getItem("user_id");
  const history = useHistory();
  const [form] = Form.useForm();

  const { data: userData, loading: isUserDataLoading } = useQuery(
    GET_USER_DETAILS,
    {
      variables: { user_id },
      fetchPolicy: "cache-and-network",
    }
  );

  const [UPDATE_USER_LAST_SCREEN_MUTATION] = useMutation(
    UPDATE_USER_LAST_SCREEN
  );

  const [CONFIRM_USER_DETAILS_MUTATION] = useMutation(CONFIRM_USER_DETAILS);

  const layout = {
    labelCol: {
      span: 24,
    },
    wrapperCol: {
      span: 24,
    },
  };

  const tailLayout = {
    wrapperCol: {
      span: 24,
    },
  };

  useEffect(() => {
    //Update Last Screen
    if (!userData?.getUsersById?.last_screen) {
      UPDATE_USER_LAST_SCREEN_MUTATION({
        variables: {
          user_id,
          last_screen: history.location.pathname,
        },
      });
    }
  }, [userData]);

  if (isUserDataLoading) {
    return <Loader />;
  }

  const onFinish = async (values) => {
    await CONFIRM_USER_DETAILS_MUTATION({
      variables: {
        user_id,
        phone: values.phone,
        email: values.email,
      },
    }).then((data) => {
      if (!data?.errors) {
        history.push("/verify-details", {
          nextPage: "/on-boarding/shift-management",
        });
      } else if (!!data?.errors) {
        if (data?.errors[0]?.extensions?.code === "constraint-violation") {
          if (data?.errors[0]?.message.includes("phone")) {
            form.setFields([
              {
                name: "phone",
                errors: ["Phone number already in-use"],
              },
            ]);
          }
          if (data?.errors[0]?.message.includes("email")) {
            form.setFields([
              {
                name: "email",
                errors: ["Email Id already in-use"],
              },
            ]);
          }
        }
      }
    });
    // if (!response.errors) {
    //   history.push("/verify-details", {
    //     nextPage: "/on-boarding/shift-management",
    //   });
    // }
    // } catch (errors) {
    //   if (
    //     errors?.graphQLErrors &&
    //     errors?.graphQLErrors[0]?.extensions?.code === "constraint-violation"
    //   ) {
    //     if (errors?.graphQLErrors[0].message.includes("phone")) {
    //       form.setFields([
    //         {
    //           name: "phone",
    //           errors: ["Phone number already in-use"],
    //         },
    //       ]);
    //     }
    //     if (errors?.graphQLErrors[0].message.includes("email")) {
    //       form.setFields([
    //         {
    //           name: "email",
    //           errors: ["Email Id already in-use"],
    //         },
    //       ]);
    //     }
    //   }
    // }
  };

  return (
    <div className="rowSec">
      <div className="colSec onBoardingLeft">
        <img src={ConfirmDetailsImage} alt="" className="" />
      </div>
      <div className="colSec onBoardingRight">
        <div className="login">
          <Title level={2}>
            Welcome to SanAttest, {userData?.getUsersById.first_name}
          </Title>
          <p className="subTitle">
            Please confirm your basic info, kindly update if required.
          </p>
          <Form
            {...layout}
            form={form}
            name="confirmForm"
            initialValues={{
              phone: userData?.getUsersById.phone,
              email: userData?.getUsersById.email,
            }}
            onFinish={onFinish}
          >
            <Form.Item
              label="Your phone number"
              name="phone"
              htmlFor="phone"
              rules={[
                {
                  required: true,
                  message: "Phone Number is required",
                  whitespace: true,
                },
                () => ({
                  validator(_, value) {
                    if (!value) {
                      return Promise.resolve();
                    }
                    if (isValidPhoneNumber(value)) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error("Enter Valid Phone Number")
                    );
                  },
                }),
              ]}
            >
              <PhoneInput
                className="phoneInput_blk"
                defaultCountry="US"
                placeholder="(201) 555-1234"
                countryOptionsOrder={["US", "CA", "|", "..."]}
                disabled
              />
            </Form.Item>
            <Form.Item
              label="Your email id"
              name="email"
              htmlFor="email"
              normalize={(value) => {
                return !value ? "" : value.toLowerCase();
              }}
              rules={[
                {
                  required: true,
                  message: "Email Address is required",
                  whitespace: true,
                },
                {
                  type: "email",
                  message: "Enter Valid Email Address",
                },
              ]}
            >
              <Input placeholder="john.dow@sanattest.com" disabled />
            </Form.Item>

            <Form.Item {...tailLayout} className="buttonSec">
              <Button
                type="primary"
                size="large"
                shape="round"
                htmlType="submit"
              >
                Continue
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
};
